<template>
  <div class="w3-greenx">
    <div class="w3-padding" style="border-bottom: 1px solid #f3efee;">
      Details
    </div>
    <div class="w3-padding">

      <div class="w3-row new-issue-detail">
        <div class="w3-col l2 s12">Status</div>
        <div class="w3-col l9 s12">
          <label class="select">
            <select v-model="formData.status" @change="statusChange($event)" class="" name="">
              <option v-for="(value, index) in ws_issue_status" :key="index" :value="value.id">{{value.title}}</option>
            </select>
          </label>
        </div>
      </div>

      <div class="w3-row new-issue-detail">
        <div class="w3-col l2 s12">Priority</div>
        <div class="w3-col l9 s12">
          <label class="select">
            <select v-model="formData.priority" class="" name="">
              <option v-for="(value, index) in ws_issue_priority" :key="index" :value="value.id">{{value.title}}</option>
            </select>
          </label>
        </div>
      </div>

      <div class="w3-row new-issue-detail">
        <div class="w3-col l2 s12">Assignee</div>
        <div class="w3-col l9 s12">
          <label class="select">
            <select v-model="formData.assignee" class="" name="">
              <option selected="" value="">Unassigned</option>
              <option v-for="(value, index) in this.workspace.users" :key="index" :value="value.id">{{value.email}}</option>
            </select>
          </label>
        </div>
      </div>

      <div class="w3-row new-issue-detail">
        <div class="w3-col l2 s12">Labels</div>
        <div class="w3-col l9 s12">
          <label class="select">
            <select v-model="formData.labels" class="" name="">
              <option selected="" value="">+ Add Label</option>
              <option v-for="(value, index) in ws_issue_label" :key="index" :value="value.id">{{value.title}}</option>
            </select>
          </label>
        </div>
      </div>

      <hr>

      <div class="w3-row new-issue-detail">
        <div class="w3-col l2 s12">Project</div>
        <div class="w3-col l9 s12">
          <label class="select">
            <select v-model="formData.project" class="" name="">
              <option selected="" value="">+ Add to project</option>
              <option v-for="(value, index) in ws_projects" :key="index" :value="value.id">{{value.name}}</option>
            </select>
          </label>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import router from '@/router'

export default {
  name: 'IssueRightDetail',

  props: {
    formData: Object,
    ws_issue_status: Array,
    ws_issue_label: Array,
    ws_issue_priority: Array,
    is_detail_edit: String
  },

  methods: {
    statusChange: function (e) {
      if (this.is_detail_edit) {
        console.log(e.target.value)
      }
    },



  },

  created: function () {

    // if (this.is_detail_edit) {
    //   alert(11)
    // }

  },

  computed: {
    ...mapGetters('auth', ['auth_state', 'user', 'isLoggedIn', 'workspaces']),
    ...mapGetters('workspace', ['ws_issues', 'ws_projects']),

    workspace: function(){
      const result = this.workspaces.find( ({ slug }) => slug === this.$route.params.slug );
      return result;
    },

    // projects: function(){
    //   const result = this.ws_projects.find( ({ slug }) => slug === this.$route.params.slug );
    //   return result;
    // },

  }

}

</script>

<style scoped="">
body{

}

.input-1, .input-2{
  border: none;
  width: 100%;
  resize: none;
  /* height: auto; */
}

.input-1{
  /* height: 60px; */
  font-size: 20px
}

.new-issue-detail{
  margin-bottom: 20px;
}

select {
    padding:4px;
    margin: 0;
    background: #fff;
    color:#888;
    border:1px solid #ececec;
    outline:none;
    display: inline-block;
    -webkit-appearance:none;
    -moz-appearance:none;
    appearance:none;
    cursor:pointer;
    width: 200px;
    -webkit-border-radius: 0px;
    -moz-border-radius: 0px;
    border-radius: 0px;
}

/* Targetting Webkit browsers only. FF will show the dropdown arrow with so much padding. */
@media screen and (-webkit-min-device-pixel-ratio:0) {
    select {padding-right:18px}
}

.select {
    position:relative
}

.select:after {
    content:"\f078";
    font-family: "FontAwesome";
    font-size: 11px;
    color:#aaa;
    right:8px; top:0px;
    padding:0 0 2px;
    position:absolute;
    pointer-events:none;
}
.select:before {
    content:'';
    right:4px; top:0px;
    width:23px; height:8px;
    background:#fff;
    position:absolute;
    pointer-events:none;
    display:block;
}

</style>
